/**
 * Heure réelle de l'image affichée au spectateur, envoyée avec ses messages et réactions.
 *
 * Elle vient de `EXT-X-PROGRAM-DATE-TIME`, la même horloge que le manifeste de la timeline
 * evergreen : le back place ainsi le message sur l'image à laquelle le spectateur réagissait.
 */
export function toPlaybackAt(playbackTimestampMs: number | null | undefined): string | undefined {
  if (
    playbackTimestampMs == null ||
    !Number.isFinite(playbackTimestampMs) ||
    playbackTimestampMs <= 0
  ) {
    return undefined;
  }
  return new Date(playbackTimestampMs).toISOString();
}
